import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AddressService } from 'src/app/services/address/address.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss'],
})
export class TransactionHistoryComponent implements OnInit {
  @ViewChild('Content') content: IonContent;
  @ViewChild('Content') table: IonContent;

  public error = null;
  public transactions: any[] = [];
  public totalRecords: number = 0;
  public currentPage: number = 1;
  public maxPage: number = 1;
  public showTable = false;
  public showNoResults = false;
  public emailMeDisabled = false;
  public searchDisabled = false;
  public toDate;
  public fromDate;
  public todayDate;
  public emailButtonText = "Email me these results";
  public itemsPerPage = 25;
  dateRange: number;

  public startDate: any;
  public showTransactionComments: boolean = false;
  
  constructor(
    public addressService: AddressService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public events: EventsService,
    public withdrawService: WithdrawalService,
    public balanceService: AccountBalanceService,
    public configService: ConfigService,
    public successMessageService: SuccessMessageService,
    private config: ConfigService,
    private timeService: TimeService
  ) {
    this.showTransactionComments = this.config.getConfig()?.FEATURE_TRANSACTION_COMMENTS === '1' ? true : false;
  }

  ngOnInit() {
    this.dateRange = parseInt(this.config.getConfig()["FEATURE_DATE_RANGE"]) || 14;
  }

  calendarUpdate(event) {
    this.toDate = event.toDate;
    this.fromDate = event.fromDate;
    this.searchDisabled = event.search;
    this.successMessageService.clearMessage();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();

    const today = new Date();
    const date = new Date();
    this.todayDate = today;

    this.startDate = new Date(date.setDate(date.getDate() - this.dateRange)); //set start date 2 weeks ago to dynamically add 2 weeks range
    this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(today)); //setting today date fallback and initial value for 'To' data passed to webservices
    this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(date)); //'From' data passed to webservice
  }

  onSearch() {
    this.searchDisabled = true;
    this.showTable = false;
    this.currentPage = 1;

    this.onGetTransactions()
  }

  onPageChange(event) {
    // this.logger.log('onPageChange TransactionHistoryPage', event);
    this.currentPage = Number(event);

    this.onGetTransactions();
  }

  onGetTransactions() {
    const requestObj: any = {};
    requestObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
    requestObj.pageno = this.currentPage;
    requestObj.date_from = this.fromDate;
    requestObj.date_to = this.toDate;

    this.showTable = false;
    this.showNoResults = false;

    this.cashierService.callGetTransactions(requestObj).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          const serverPageSize = response.payload.page_size;
          const serverTotalPages = response.payload.total_pages;
          const pageNumber = Number(response.payload.page_no);

          this.totalRecords = response.payload.count;
          this.transactions = response.payload.page_data;
          this.currentPage = pageNumber;
          this.maxPage = response.payload.total_pages;

          if (this.totalRecords > 0) {
            this.showTable = true;
            this.showNoResults = false;
          }
          else {
            this.showTable = false;
            this.showNoResults = true;
          }

          this.emailMeDisabled = false;
          this.table.scrollToTop();
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  onEmailMeClicked() {
    console.log('onEmailMeClicked TransactionHistoryPage');
    const requestObj: any = {};
    requestObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
    requestObj.date_from = this.fromDate;
    requestObj.date_to = this.toDate;
    this.cashierService.sendTransactionsEmail(requestObj).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.emailMeDisabled = true;
          this.emailButtonText = "Email sent"
          this.successMessageService.setMessage("An email with all results has been sent.");
          this.content.scrollToTop();
        }
      },
      (error) => {
        this.error = error;
        this.successMessageService.clearMessage();
      }
    );
  }
}
